/**
 * PrivacyModal - Modale condiviso per l'informativa privacy ANUTEL ETS
 * Riusato sia in fase di registrazione (consenso obbligatorio) sia nella
 * scheda di prenotazione iniziativa (richiamo informativo).
 */
import { PRIVACY_POLICY } from '../../utils/constants';

const PrivacyModal = ({ closeModal }) => {
  return (
    <div className="p-6 max-h-[80vh] overflow-y-auto">
      <h2 className="text-xl font-bold text-gray-900 mb-1">{PRIVACY_POLICY.titolo}</h2>
      <p className="text-sm font-medium text-gray-600 mb-1">{PRIVACY_POLICY.sottotitolo}</p>
      <p className="text-xs text-gray-400 mb-4">{PRIVACY_POLICY.riferimento}</p>

      <p className="text-sm text-gray-700 mb-6 leading-relaxed">{PRIVACY_POLICY.premessa}</p>

      {PRIVACY_POLICY.sezioni.map((sezione) => (
        <div key={sezione.numero} className="mb-5">
          <h3 className="text-base font-bold text-gray-800 mb-2">
            {sezione.numero}. {sezione.titolo}
          </h3>
          {sezione.blocchi.map((blocco, idx) =>
            blocco.tipo === 'lista' ? (
              <ul key={idx} className="list-disc list-inside text-sm text-gray-700 space-y-1 mb-3 ml-2">
                {blocco.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            ) : (
              <p key={idx} className="text-sm text-gray-700 leading-relaxed mb-3">
                {blocco.testo}
              </p>
            )
          )}
        </div>
      ))}

      <div className="mt-6 flex justify-end">
        <button
          onClick={closeModal}
          className="px-4 py-2 bg-anutel hover:bg-anutel-dark text-white rounded-lg font-medium transition-colors"
        >
          Ho capito
        </button>
      </div>
    </div>
  );
};

export default PrivacyModal;
